import type { LocationContent } from "../types";

import { barnsley } from "./barnsley";
import { doncaster } from "./doncaster";
import { huddersfield } from "./huddersfield";
import { leeds } from "./leeds";
import { rotherham } from "./rotherham";
import { sheffield } from "./sheffield";
import { wakefield } from "./wakefield";

export const locations: Record<string, LocationContent> = {
  barnsley, doncaster, huddersfield, leeds, rotherham, sheffield, wakefield,
};

export const locationSlugs = Object.keys(locations);

export function getLocation(slug: string): LocationContent | undefined {
  return locations[slug];
}
